module.exports = __webpack_public_path__ + "static/img/ios_download.76ba8827.png";